module.exports = __webpack_public_path__ + "img/img5.167eadf1.svg";